import { externalActionCreators as signTransferActionCreators } from '@app/components/SignTransferModal/modules/signTransfer'
import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import PendingTransferItem from '../components/PendingTransferItem'

export default connect(
  createStructuredSelector<ApplicationState, ICurrentUserState>({
    user: selectCurrentUser(),
  }),
  signTransferActionCreators,
)(PendingTransferItem)
